/* global globalThis */
import { API } from "./base.service";
import {
  REAL_MS,
  PROTOCOL,
  OPENID_CONNECT,
  REVOKE,
  KEYCLOAK,
} from "./APIConstants/api.constant";



/**
 * Revoke access token at Keycloak (RFC 7009)
 * @param {Object} payload - Contains token, token_type_hint, and client_id
 * @returns {Promise} - Axios POST promise
 */
export const revokeAccessToken = (payload) => {
  return API.post(
    `${KEYCLOAK}${REAL_MS}/${globalThis?.SSO_REALM}${PROTOCOL}${OPENID_CONNECT}${REVOKE}`,
    payload
  );
};
